import { connect } from 'react-redux';
import { userModalActions } from 'components/usersModal';
import { withCountries } from 'hocs';
import { bindActionToPromise } from 'utils/sagaApiGeneratorHelpers';
import { twilioActions } from '../../../../app/middleware/twilio/actions/twilioActions';
import { actions } from '../../../telephony/actions/telephony';
import { SearchUser } from '../components/SearchUser/SearchUser';
const mapStateToProps = (state) => {
    return {
        ui: state.telephony.ui,
        meta: state.telephony.meta,
        telephonyMeta: state.twilio.meta,
        selectedFromNumber: state.telephony.selectedFromNumber,
        currentCall: state.telephony.currentCall,
        users: state.telephony.users,
        dynamicTelephoneNumbersArray: state.telephony.dynamicTelephoneNumbersArray,
        staticTelephoneNumbersArray: state.telephony.staticTelephoneNumbersArray,
        profile: state.settings.profile.profile,
        searchValue: state.telephony.searchValue,
        isOnTrial: typeof state.settings.organization.organization.trial_ended_at ===
            'string'
            ? false
            : true,
    };
};
const mapDispatchToProps = (dispatch) => {
    return {
        resetUsers: () => dispatch(actions.telephonyResetUsers()),
        editUser: (user) => dispatch(userModalActions.show({ user })),
        setSearchUserValue: (payload) => dispatch(actions.telephonySetSearchValue(payload)),
        userModalAddUser: (payload) => dispatch(userModalActions.user.add(payload)),
        getUsersByQuery: bindActionToPromise(dispatch, actions.telephonyGetUsersByQuery),
        telephonySetBlocked: () => dispatch(actions.telephonyResetUsers()),
        telephonyMakeCall: bindActionToPromise(dispatch, twilioActions.twilioMakeCall),
    };
};
const SearchUserWithCountries = withCountries(SearchUser);
export default connect(mapStateToProps, mapDispatchToProps)(SearchUserWithCountries);
